// 取消理由列表兜底
export default [
  {
    levelOneId: 21,
    levelOneReason: '个人原因',
    levelTwoReasonInfo: [
      {
        id: 24,
        priority: 1,
        reason: '临时有事，暂不用车',
      },
      {
        id: 25,
        priority: 2,
        reason: '赶时间，换用其它交通工具',
      },
      {
        id: 26,
        priority: 3,
        reason: '选错上车点',
      },
      {
        id: 27,
        priority: 4,
        reason: '在其它平台打到车了',
      },
      {
        id: 28,
        priority: 5,
        reason: '车主已到达，来不及上车',
      },
    ],
  },
  {
    levelOneId: 22,
    levelOneReason: '车主原因',
    levelTwoReasonInfo: [
      {
        id: 29,
        priority: 1,
        reason: '车主不愿意来接我',
      },
      {
        id: 30,
        priority: 2,
        reason: '联系不上车主',
      },
      {
        id: 31,
        priority: 3,
        reason: '车主迟到',
      },
      {
        id: 32,
        priority: 4,
        reason: '车主原地不动或越来越远',
      },
      {
        id: 33,
        priority: 5,
        reason: '车主打电话态度不好',
      },
      {
        id: 34,
        priority: 6,
        reason: '车主要求加价或现金交易',
      },
      {
        id: 35,
        priority: 7,
        reason: '车主要求我取消',
      },
      {
        id: 36,
        priority: 8,
        reason: '车辆不符合我的要求',
      },
      {
        id: 37,
        priority: 9,
        reason: '车牌号与订单显示不一致',
      },
    ],
  },
  {
    levelOneId: 23,
    levelOneReason: '平台原因',
    levelTwoReasonInfo: [
      {
        id: 38,
        priority: 1,
        reason: '上车点定位不准',
      },
      {
        id: 39,
        priority: 2,
        reason: '车主离我太远',
      },
      {
        id: 40,
        priority: 3,
        reason: '车主接驾时间太久',
      },
    ],
  },
];
